import { render, staticRenderFns } from "./ModalPLPFilters.vue?vue&type=template&id=35f53bc3&scoped=true&"
import script from "./ModalPLPFilters.vue?vue&type=script&lang=js&"
export * from "./ModalPLPFilters.vue?vue&type=script&lang=js&"
import style0 from "./ModalPLPFilters.vue?vue&type=style&index=0&id=35f53bc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f53bc3",
  null
  
)

export default component.exports